import { IngredientAllergensCard } from 'components/desktop/Ingredient/Cards/IngredientAllergensCard';
import { IngredientBaseIngredientCard } from 'components/desktop/Ingredient/Cards/IngredientBaseIngredientCard';
import { IngredientBaseIngredientOverwriteCard } from 'components/desktop/Ingredient/Cards/IngredientBaseIngredientOverwriteCard';
import { IngredientCharacteristicsCard } from 'components/desktop/Ingredient/Cards/IngredientCharacteristicsCard';
import { IngredientCostCard } from 'components/desktop/Ingredient/Cards/IngredientCostCard';
import { IngredientScalingFactorCard } from 'components/desktop/Ingredient/Cards/IngredientScalingFactorCard';
import { IngredientSeasonsCard } from 'components/desktop/Ingredient/Cards/IngredientSeasonsCard';
import { IngredientTagsCard } from 'components/desktop/Ingredient/Cards/IngredientTagsCard';
import { IngredientWeightCard } from 'components/desktop/Ingredient/Cards/IngredientWeightCard';
import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';

const TabMetaData = (props: IngredientTabProps) => {
	return (
		<div className="row mt-4">
			<div className="col-4 d-flex flex-column" style={{ gap: '15px' }}>
				<IngredientBaseIngredientCard {...props} />
				<IngredientBaseIngredientOverwriteCard {...props} />
				<IngredientCharacteristicsCard {...props} />
				<IngredientWeightCard {...props} />
			</div>
			<div className="col-4 d-flex flex-column" style={{ gap: '15px' }}>
				<IngredientCostCard {...props} />
				<IngredientScalingFactorCard {...props} />
				<IngredientAllergensCard {...props} />
			</div>
			<div className="col-4 d-flex flex-column" style={{ gap: '15px' }}>
				<IngredientSeasonsCard {...props} />
				<IngredientTagsCard {...props} />
			</div>
		</div>
	);
};

export default TabMetaData;
